module.exports = __webpack_public_path__ + "static/media/8.08bdd79c.jpg";